import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { ApiClient } from '../../../../api/ApiClient';
import { v2 } from '../../../../api/ApiInterfaceV2';
import { JiraIssueTypeData } from '../../../../api/endpoints/jira';
import { useResolve } from '../../../Container';
import { Flexer } from '../../../dashboard/elements/LayoutElements';
import { JiraPopperActionMenu, JiraPopperActionMenuFilterableItems } from '../fields/JiraPopperActionMenu';
import { useSelectedItemsIfApplicable } from './JiraMenuHooks';

const useJiraProjectIssueTypeListQuery = (jiraProjectId: string) => {
    const api = useResolve(ApiClient);
    return useQuery({
        queryKey: ['v2.jira.projects.issueTypes.list', jiraProjectId],
        queryFn: async () => api.exec(v2.jira.projects.issueTypes.list(jiraProjectId)),
    });
};

export type JiraProjectIssueTypeMenuProps = {
    jiraProjectId: string,
    selected?: JiraIssueTypeData[],
    multi?: boolean,
    onSelect(item: JiraIssueTypeData): void,
};

export const JiraProjectIssueTypeMenu = ({ jiraProjectId, selected, multi, onSelect }: JiraProjectIssueTypeMenuProps) => {
    const { isLoading, data } = useJiraProjectIssueTypeListQuery(jiraProjectId);
    const [dataWithSelected, selectedKey] = useSelectedItemsIfApplicable(data, selected?.map(x => x.id));
    return <Flexer width="16">
        <JiraPopperActionMenu loading={isLoading} label="Issue Type">
            <JiraPopperActionMenuFilterableItems
                data={multi ? dataWithSelected : data}
                idKey="id"
                labelKey="name"
                iconKey="iconUrl"
                selectedKey={multi ? selectedKey : undefined}
                onClick={onSelect}
            />
        </JiraPopperActionMenu>
    </Flexer>;
};
